import { render, staticRenderFns } from "./left.vue?vue&type=template&id=9740c7bc&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"
import style0 from "./left.vue?vue&type=style&index=0&id=9740c7bc&prod&lang=less&"
import style1 from "./left.vue?vue&type=style&index=1&id=9740c7bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9740c7bc",
  null
  
)

export default component.exports